import { DateTime } from 'luxon';
import { ProfileContext } from '../../../contexts/ProfileContext';
import { getGameCardConfiguration } from '../../../configuration/gamesConfiguration';
import { useGraphQL } from '../../../hooks/useGraphQL';
import { useHistory } from 'react-router-dom';
import Button from '../buttons/Button';
import GameSelectCardCodeInput from './GameSelectCardCodeInput';
import React, { useContext, useEffect, useState } from 'react';

const DEFAULT_ERROR =
    'Jméno týmu musí obsahovat alespoň 3 znaky a může obsahovat písmena, čísla, mezery a speciální znaky tečku, podtržítko a pomlčku.';

function GameSelectCard() {
    const history = useHistory();
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(DEFAULT_ERROR);
    const [code, setCode] = useState('');
    const [allowStart, setAllowStart] = useState(false);
    const { saveTeamName } = useGraphQL();
    const [nameSent, setNameSent] = useState(false);
    const { availableGame } = useContext(ProfileContext);

    if (!availableGame) {
        return null;
    }
    const { gameType, validTo } = availableGame;
    // @ts-expect-error
    const gameCardConfiguration = getGameCardConfiguration(gameType);

    useEffect(() => {
        if (nameSent && availableGame?.teamName === null) {
            setErrorMessage('Jméno je již obsazeno.');
            setError(true);
        } else if (availableGame?.teamName !== null) {
            setAllowStart(true);
            if (gameCardConfiguration !== null) {
                history.push({
                    pathname: gameCardConfiguration.gameUrl,
                });
            }
        }
    }, [availableGame]);

    const validateCode = () => {
        const re = new RegExp(
            '^[äÄAaÁáBbCcČčDdĎďEeÉéĚěFfGgHhIiÍíJjKkLlMmNnŇňOoÓóôÔPpQqRrŘřSsŠšTtŤťUuÚúůŮVvWwXxYyÝýZzŽž0-9](([._-]|\\s)(?!([._-]|\\s))|[äÄAaÁáBbCcČčDdĎďEeÉéĚěFfGgHhIiÍíJjKkLlMmNnŇňOoÓóôÔPpQqRrŘřSsŠšTtŤťUuÚúůŮVvWwXxYyÝýZzŽž0-9]){1,19}[äÄAaÁáBbCcČčDdĎďEeÉéĚěFfGgHhIiÍíJjKkLlMmNnŇňOoÓóôÔPpQqRrŘřSsŠšTtŤťUuÚúůŮVvWwXxYyÝýZzŽž0-9]$',
        );
        if (re.test(code)) {
            // @ts-expect-error
            saveTeamName(code, availableGame.token);
            setNameSent(true);
        } else {
            setError(true);
            setAllowStart(false);
            setErrorMessage(DEFAULT_ERROR);
            setNameSent(false);
        }
    };

    const onCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCode(e.target.value);
        setError(false);
    };

    return (
        <div className="game-select-wrapper">
            <div className="card game-select-card">
                <div className="game-select-card__image-wrapper">
                    <div
                        className="game-select-card__image"
                        style={{
                            backgroundImage: `url("${gameCardConfiguration?.background}")`,
                        }}
                    />
                    {gameCardConfiguration?.showValidity && (
                        <div className="game-select-card__image-details">
                            {validTo && (
                                <Button className="primary-button">
                                    {'do ' + DateTime.fromSeconds(parseInt(validTo)).toFormat('dd.MM.yyyy')}
                                </Button>
                            )}
                        </div>
                    )}
                </div>
                <div className="game-select-card__post-wrapper">
                    <h1 className="game-select-card__title">{gameCardConfiguration?.title}</h1>
                    <h2 className="game-select-card__subtitle">{gameCardConfiguration?.subtitle}</h2>
                    <GameSelectCardCodeInput
                        errorMessage={errorMessage}
                        onClick={validateCode}
                        onChange={onCodeChange}
                        code={code}
                        error={error}
                    />
                    {allowStart && (
                        <div className="game-select-card__button">
                            <a href={gameCardConfiguration?.gameUrl}>Zvolit hru &rarr;</a>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default GameSelectCard;
